import React, { Component, Fragment } from 'react'
import AppURL from '../api/AppURL'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import Categories from '../components/home/Categories'
import Collection from '../components/home/Collection'
import FeaturedProducts from '../components/home/FeaturedProducts'
import HomeTop from '../components/home/HomeTop'
import HomeTopMobile from '../components/home/HomeTopMobile'
import NewArrival from '../components/home/NewArrival'
import axios from 'axios'


export class HomePage extends Component {


     // এই লাইনটি উইন্ডো স্ক্রল করার জন্য ব্যবহার করা হয়, যাতে পেজটি স্ক্রল করে শুরুর দিকে (x=0, y=0) নিয়ে যায়। এটি সাধারণত ব্যবহার করা হয় যখন আপনি চান যে ব্যবহারকারী পেজে প্রবেশ করার পর সবসময় শুরুর দিকে দেখা যাক।

     // GetVisitorDetails  এই লাইনটি একটি মন্তব্য হিসেবে রয়েছে, লাইনটি নির্দেশ করে যে এখানে GetVisitorDetails নামে একটি ফাংশনকে কল করার পরিকল্পনা ছিল, যা সম্ভবত ভিজিটরের বিস্তারিত তথ্য পাওয়ার জন্য ব্যবহৃত হবে। কিন্তু এই লাইনে কোন কার্যকরী কোড নেই, অর্থাৎ এই ফাংশনটি কল হচ্ছে না।
     

// এই GetVisitorDetails ফাংশনটি একটি API কল করার জন্য তৈরি করা হয়েছে, যেখানে axios লাইব্রেরি ব্যবহার করা হয়েছে। 
//axios.get(AppURL.VisitorDetails) এই লাইনে, axios একটি HTTP GET রিকুয়েস্ট পাঠাচ্ছে AppURL.VisitorDetails এ উল্লেখিত URL-এর দিকে। 
//এই ফাংশনের কাজ হলো উক্ত URL থেকে তথ্য (ডেটা) সংগ্রহ করা।

//বিস্তারিত:

//axios.get(AppURL.VisitorDetails) – এই অংশটি AppURL.VisitorDetails নামক URL-এ GET রিকুয়েস্ট পাঠায় এবং সেখানে যদি সঠিকভাবে রেসপন্স আসে, 
//তবে তা .then() অংশে চলে যাবে। then() ফাংশন সাধারণত সফল রেসপন্স পাওয়ার পর কী করতে হবে তা নির্ধারণ করে।

//.catch() – এটি ত্রুটি (error) ধরার জন্য ব্যবহার করা হয়। যদি রিকুয়েস্টে কোনো সমস্যা হয় (যেমন সার্ভার সমস্যা বা নেটওয়ার্ক ত্রুটি), তবে .catch() অংশটি 
//কার্যকর হবে।

//এই কোডটি সম্পূর্ণ করতে হলে .then() এবং .catch() অংশে কিছু কার্যক্রম নির্ধারণ করতে হবে, যাতে রেসপন্স পেলে বা কোনো ত্রুটি ঘটলে কী করতে হবে 
//তা নির্দিষ্ট করা যায়।

     
     componentDidMount(){
          window.scroll(0,0);
          this.GetVisitorDetails();
     }

     GetVisitorDetails =()=>{
          axios.get(AppURL.VisitorDetails).then().catch()
     }


     render() {
          return (
               // <Fragment> 
               //      <div className="Desktop">
               // <NavMenuDesktop />
               // <HomeTop />
               //      </div>

               //      <div className="Mobile">
               //      <NavMenuMobile />  
               //      <HomeTopMobile />
               //      </div>                       

               //      <FeaturedProducts />
               //      <NewArrival />
               //      <Categories />
               //      <Collection />

               //      <div className="Desktop">
               //      <FooterDesktop/>
               //      </div>

               //      <div className="Mobile">
               //      <FooterMobile/>
               //      </div>

               // </Fragment>
               <Fragment>
                    <div className="Desktop">
                         <NavMenuDesktop />
                         <HomeTop />
                    </div>

                    <div className="Mobile">
                         <NavMenuMobile />
                         <HomeTopMobile />
                    </div>
                    <FeaturedProducts />
                    <NewArrival />
                    {/* categories er overflow problem pore dekhchi */}
                    <Categories />
                    <Collection />
                    <div className="Desktop">
                         <FooterDesktop />
                    </div>

                    <div className="Mobile">
                         <FooterMobile />
                    </div>

               </Fragment>
          )
     }
}

export default HomePage
